import { useEffect, useRef } from 'react';
import { tracker } from '..';

type UseProductRatingViewedMonitorArgs = {
  productId?: string | null;
  avgRating?: number | null;
  reviewCount: number;
  /** Gate on the reviews rollout flag so the event only fires where the rating UI renders. */
  enabled: boolean;
};

/** Fires productRatingViewed when a product's rating summary is shown. Fires once per productId. */
export const useProductRatingViewedMonitor = ({
  productId,
  avgRating,
  reviewCount,
  enabled,
}: UseProductRatingViewedMonitorArgs): void => {
  const firedForProductId = useRef<string | null>(null);

  useEffect(() => {
    // Matches ProductTitleRating's render condition — no rating UI is shown for unreviewed products.
    if (!enabled || !productId || reviewCount <= 0 || firedForProductId.current === productId) {
      return;
    }
    firedForProductId.current = productId;

    tracker.productRatingViewed({ productId, avgRating, reviewCount });
  }, [enabled, productId, avgRating, reviewCount]);
};
